// import Vuex from 'vuex';
// import { createStore } from "vuex";

import applicationModule, { initialApplicationState } from './modules/application'
import globalDrawerModule, { initialDrawerState } from './modules/globalDrawer'
import secondaryNavigationModule, { initialNavigationState } from './modules/navigation'
import segmentModule, { initialSegmentState } from './modules/segment'
import authModule, { initialAuthState } from './modules/auth'
import campaignModule, { initialCampaignState } from './modules/campaign'
import eventModule, { initialEventState } from './modules/event'
import messageModule, { initialMessageState } from './modules/message'
import messageListModule, { initialMessageListState } from './modules/messageList'
import audienceModule, { initialAudienceState } from './modules/audience'
import tagModule, { initialTagState } from './modules/tag'
import signupFormModule, { initialSignupFormState } from './modules/signupForm'
import facebookMessengerIntegrationModule, { initialFacebookMessengerIntegrationState } from './modules/facebookMessengerIntegration'
import customerModule, { initialCustomerState } from './modules/customer'
import automationModule, { initialAutomationState } from './modules/automation'
import promoterTasksModule, { initialPromoterTasksState } from './modules/promoterTasks'
import customFieldModule, { initialCustomFieldStates } from './modules/customFields'
import insightModule, { initialInsightStates } from './modules/insights'
import shortUrlModule, { initialShortUrlState } from './modules/shortUrl'

import applicationPlugin from './modules/application/plugin'
import oneschemaModule, { initialOneschemaState } from './modules/oneschema'
import customCalendarEntryModule, { initialCustomCalendarEntryState } from './modules/customCalendarEntry'
import { setValueAtPath } from '@/utils/util.js'

// TODO - make this file a .ts file
// import { RootState } from './modules/types';

const modules = {
  applicationModule: applicationModule,
  globalDrawerModule: globalDrawerModule,
  secondaryNavigationModule: secondaryNavigationModule,
  segmentModule: segmentModule,
  authModule: authModule,
  campaignModule: campaignModule,
  eventModule: eventModule,
  messageModule: messageModule,
  messageListModule: messageListModule,
  audienceModule: audienceModule,
  tagModule: tagModule,
  signupFormModule: signupFormModule,
  customerModule: customerModule,
  automationModule: automationModule,
  facebookMessengerIntegrationModule: facebookMessengerIntegrationModule,
  promoterTasksModule: promoterTasksModule,
  customFieldModule: customFieldModule,
  oneschemaModule: oneschemaModule,
  insightModule: insightModule,
  shortUrlModule: shortUrlModule,
  customCalendarEntryModule: customCalendarEntryModule,
}

// Initial State
export const initialState = () => ({
  applicationModule: initialApplicationState(),
  globalDrawerModule: initialDrawerState(),
  secondaryNavigationModule: initialNavigationState(),
  segmentModule: initialSegmentState(),
  authModule: initialAuthState(),
  eventModule: initialEventState(),
  campaignModule: initialCampaignState(),
  messageModule: initialMessageState(),
  messageListModule: initialMessageListState(),
  audienceModule: initialAudienceState(),
  tagModule: initialTagState(),
  signupFormModule: initialSignupFormState(),
  customerModule: initialCustomerState(),
  automationModule: initialAutomationState(),
  facebookMessengerIntegrationModule: initialFacebookMessengerIntegrationState(),
  promoterTasksModule: initialPromoterTasksState(),
  customFieldModule: initialCustomFieldStates(),
  oneschemaModule: initialOneschemaState(),
  insightModule: initialInsightStates(),
  shortUrlModule: initialShortUrlState(),
  customCalendarEntryModule: initialCustomCalendarEntryState(),
  // route: {},
})

const storeConfig = {
  modules: modules,
  // stateModule: initialState,
  mutations: {
    RESET_STATE: (state) => {
      Object.assign(state, initialState())
    },
    SET_LOADING_STATE: (state, { key, value }) => {
      try {
        setValueAtPath(state, key, value)
      }
      catch (_e) {
        console.warn(`SET_LOADING_STATE: Could not set loading state for key "${key}"`)
      }
    },
    SET_CACHE: (state, { key, value }) => {
      try {
        setValueAtPath(state, key, value)
      }
      catch (_e) {
        console.warn(`SET_CACHE: Could not set cached data for key "${key}"`)
      }
    },
    CONCAT_CACHE: (state, { key, value }) => {
      try {
        setValueAtPath(state, key, [
          ...(getValueAtPath(state, key) || []),
          ...value,
        ])
      }
      catch (_e) {
        console.warn(`CONCAT_CACHE: Could not concat result with cached data for key "${key}"`)
      }
    },
    RESET_STATE_KEY: (state, key) => {
      // Resets a specific state module
      if (state[key] && initialState()[key]) {
        Object.assign(state[key], initialState()[key])
      }
    },
  },
  plugins: [applicationPlugin],
}
// const createStore = () => new Vuex.Store(storeConfig)
// const createStoreFromVuex = createStore(storeConfig)
export default storeConfig
